import type { PropertyValue } from 'state/data/dataState';

/**
 * Normalizes an edited property value for the node update endpoint (PUT `.../nodes/{nodeId}`).
 *
 * Values are sent as strings, and an empty value is sent as `null` regardless of property type:
 * clearing a property removes its key from the node in Neo4j, and the node DTO omits empty
 * properties, so `null` — not `''` — is what "cleared" means on the wire.
 */
export function normalizePropertyValue(value: PropertyValue): PropertyValue {
  if (value === null || (typeof value === 'string' && value.trim() === '')) return null;

  return String(value);
}
